import ApiService from "./api";

const Compendium = {
  get(resource, params, locale) {
    return ApiService.get(`compendium/${resource}/${locale}`, {params: params});
  },
};

export default Compendium;
